import Set from './_Set.js';
import noop from './noop.js';
import setToArray from './_setToArray.js';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

export default createSet;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_createSet.js
// module id = 2246
// module chunks = 67